export const SET_THEME = 'app/SET_THEME';

export const setTheme = (payload) => {
  localStorage.setItem('theme', payload);
  return { type: SET_THEME, payload }
};
